import { useQuery as reactQueryUseQuery, } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import invariant from "tiny-invariant";
import { getContext } from "./bootstrap";
import { invalidateQueriesOnce } from "./invalidationDeduper";
import { getConformantId, getDefaultQueryIdentifier, } from "./queryKey";
import { deriveStatus } from "./queryStatus";
import { useEvent } from "./useEvent";
export const useQuery = ({ id, query, invalidation, invalidationId, invalidationDelay, invalidationRefetchType = "all", options = {}, contextId, }) => {
    const { messaging: messagingContext, queryClient: queryClientContext } = getContext({ id: contextId });
    const queryClient = useContext(queryClientContext);
    const { queryBus } = useContext(messagingContext);
    invariant(queryBus, "You are trying to use the useQuery hook without wrapping your app with the <MessagingProvider>: there is no queryBus.");
    invariant(queryClient, "You are trying to use the useQuery hook without wrapping your app with the <MessagingProvider>: there is no queryClient.");
    const queryId = id ? getConformantId(id) : getDefaultQueryIdentifier(query);
    const invalidateQueriesId = invalidationId
        ? getConformantId(invalidationId)
        : queryId;
    useEvent({
        callback: () => invalidateQueriesOnce({
            queryClient,
            queryKey: invalidateQueriesId,
            refetchType: invalidationRefetchType,
        }),
        filter: invalidation,
        delay: invalidationDelay,
        contextId,
    });
    const queryFn = useCallback(async ({ signal }) => await queryBus(query, signal), [query, queryBus]);
    const { data, status, fetchStatus } = reactQueryUseQuery({
        // Spread first on purpose: consumers must not override `queryKey`/`queryFn`.
        ...options,
        queryKey: queryId,
        queryFn,
    }, queryClient);
    return [data, deriveStatus({ status, fetchStatus })];
};
